import React, { useState } from "react";
import { Menu, MenuItem, IconButton, Avatar, Divider } from "@mui/material";
import { FaUser, FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
const ProfileDropdown = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  const {user} = useSelector((state)=>state.user)
  console.log(user , "userrrrrrrrr")

    const navigate =useNavigate()
  // Handle dropdown toggle
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = ()=>{
    localStorage.removeItem("token")
    navigate("/")
  }
  return (
    <div>
      {/* Profile Icon (Avatar) */}
      <IconButton onClick={handleClick}>
        <Avatar sx={{ bgcolor: "#f5a3b7", width: 45, height: 45, fontSize: 18, fontWeight: "bold" }}>
          {user?.first_name?.slice(0,1).toUpperCase()}
        </Avatar>
      </IconButton>

      {/* Dropdown Menu */}
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ mt: 1 }}
      >
        <MenuItem onClick={()=>{navigate('/userDashboard')}}  sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <FaUser style={{ color: "#f5a3b7" }} /> My Account
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <FaSignOutAlt style={{ color: "#f5a3b7" }} /> Logout
        </MenuItem>
      </Menu>
    </div>
  );
};

export default ProfileDropdown;
